import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "input-email",
  "use": "input-email-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 18\" id=\"input-email\"><path fill=\"#449AFF\" d=\"M18 14.586V3.414L11.794 9 18 14.586zm-9-3.071L7.228 9.92l-6.206 5.586h15.956L10.772 9.92 9 11.515zm7.978-9.021H1.022L9 9.675l7.978-7.181zM0 3.414v11.172L6.206 9 0 3.414z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol